<template>
    <form>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{name}}</p>
            </header>
            <section class="modal-card-body  has-text-centered">
                <div>
                    <div @click="toggle('isFirst')">
                        <b-switch v-model="selection.isFirst">第1候補</b-switch>
                    </div>
                    <div @click="toggle('isSecond')">
                        <b-switch v-model="selection.isSecond">第2候補</b-switch>
                    </div>
                    <div @click="toggle('isThird')">
                        <b-switch v-model="selection.isThird">第3候補</b-switch>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">キャンセル</button>
                <button class="button is-info" type="button" @click="confirm(id)">決定</button>
            </footer>
        </div>
        <!-- created後のpropsにアクセスができないため受け取り後のみここに置く -->
        <div class="hidden" id="isFirst">{{parentSelection.isFirst}}</div>
        <div class="hidden" id="isSecond">{{parentSelection.isSecond}}</div>
        <div class="hidden" id="isThird">{{parentSelection.isThird}}</div>
        <div class="hidden" id="peopleId">{{id}}</div>
    </form>
</template>

<script>
import { Toast } from 'buefy/dist/components/toast'

export default {
    data(){
        return{
            selection: {
                isFirst: false,
                isSecond: false,
                isThird: false,
            },
        }
    },
    props:{
        "id": {type: String},
        "name": {type: String},
        "parentSelection": {type: Object}
    },
    mounted(){
        // ダイアログに表示した人が選択中かどうか
        this.selection.isFirst =  (document.getElementById("isFirst").innerText  === "true")? true: false;
        this.selection.isSecond = (document.getElementById("isSecond").innerText === "true")? true: false;
        this.selection.isThird =  (document.getElementById("isThird").innerText  === "true")? true: false;
        this.$toast.open({
            duration: 3000,
            message: `[チュートリアル]  第〇〇候補のボタンを押してみましょう！`,
            position: 'is-top',
            type: 'is-info'
        })
    },
    updated(){
        this.$toast.open({
            duration: 2000,
            message: `[チュートリアル]  決定ボタンを押してみましょう！`,
            position: 'is-top',
            type: 'is-info'
        })
    },
    destroyed(){
        let candidateNum = 0;
        if(this.selection.isFirst)candidateNum = 1;
        if(this.selection.isSecond)candidateNum = 2;
        if(this.selection.isThird)candidateNum = 3;
        if(candidateNum){
            this.$toast.open({
                duration: 3000,
                message: `${this.name}をマッチングしたい相手の第${candidateNum}候補に選びました！`,
                position: 'is-bottom',
                type: 'is-info'
        })
        }
        this.$toast.open({
            duration: 3000,
            message: `[チュートリアル]  結果発表ボタン(右上)を押してみましょう！`,
            position: 'is-bottom',
            type: 'is-info'
        })
    },
    methods:{
        toggle: function(chose){
            if(this.selection[chose])return false;
            for(let key in this.selection){
                if(key === chose)continue;
                this.selection[key] = false;
            }
        },
        confirm: function(id){
            let selected = false;
            for(let key in this.selection){
                if(this.selection[key]){
                    this.$emit("confirm", key, document.getElementById("peopleId").innerText);
                    selected = true;
                }
            }
            // 誰も選択しなかった場合
            if(!selected){
                this.$emit('confirm', null, document.getElementById('peopleId').innerText);
            }
            this.$parent.close();
            return true;
        },
    }
}
</script>

<style scoped>
.modal-card{
    --width: 60%;
    width: var(--width);
    left: calc((100% - var(--width))/2);
}
.hidden{
    display: none;
}
</style>